// extracted by mini-css-extract-plugin
export var hero = "styles-module--hero--OBWI8";
export var colorOverlay = "styles-module--colorOverlay--dNxSh";
export var twoColors = "styles-module--twoColors--T5n53";
export var innerContainer = "styles-module--innerContainer--Qjjd1";
export var left = "styles-module--left--SEdEm";
export var center = "styles-module--center---li9K";
export var right = "styles-module--right--oLfXa";
export var heroContainer = "styles-module--heroContainer--jiecE";
export var link = "styles-module--link--YisBc";